export enum FormTypes {
    INPUT = 0,
    TEXTAREA,
    CHEKBOX,
    SELECT,
    DATE,
    RADIO,
    NUMBER_PICKER
}